import client from "directus/src/client";
import {
  customEndpoint,
  getDirectusField,
  getItemFromCollection,
  getItemsFromCollection,
} from "directus/src/operations";

export async function fetchContractMeta({ contractId }) {
  try {
    const query = {
      fields: [
        "id",
        "name",
        "status",
        "type",
        "project.id",
        "project.name",
        "project.project_id",
        "jobs.id",
        "jobs.name",
      ],
    };
    const response = await getItemFromCollection("contracts", contractId, query);
    return response;
  } catch (error) {
    console.error(error);
    throw error;
  }
}

export async function fetchContractJobsCount({ contractId }) {
  try {
    const query = {
      filter: {
        contract: { _eq: contractId },
      },
      aggregate: {
        countDistinct: ["id"],
      },
    };
    const response = await getItemsFromCollection("jobs", query);
    return response?.[0]?.countDistinct.id;
  } catch (error) {
    console.error(error);
    throw error;
  }
}

export async function fetchContractStatuses() {
  try {
    const response = await getDirectusField("contracts", "status");

    const data = response.meta.options.choices.map((status) => {
      return { name: status.text, id: status.value };
    });
    return data;
  } catch (error) {
    console.log(error);
    throw error;
  }
}

export async function fetchContractTypes() {
  try {
    const response = await getDirectusField("contracts", "type");

    const data = response.meta.options.choices.map((type) => {
      return { name: type.text, id: type.value };
    });
    return data;
  } catch (error) {
    console.log(error);
    throw error;
  }
}

export async function fetchContractRevenueCalculation({ contractId, startDate, endDate, jobTagId }) {
  try {
    const params = new URLSearchParams();
    if (contractId) params.append("contractId", contractId);
    if (startDate) params.append("start_date", startDate);
    if (endDate) params.append("end_date", endDate);
    if (jobTagId) params.append("jobTagId", jobTagId);

    const response = await client.request(
      customEndpoint({
        path: `/revenue-calculation/contract-dashboard?${params.toString()}`,
        method: "GET",
      })
    );
    return response?.data ?? response;
  } catch (error) {
    console.error(error);
    throw error;
  }
}
